import { Text } from "@mantine/core";
import { DataGridSelectionKeys, DBStatusResult, EntityClientAction, LookupFormAction } from "@mcurros2/microm";
import { Personal } from "../Personal";
import { PersonalTiendas } from "./PersonalTiendas";

export const ACTReasignarTienda: EntityClientAction = {
    name: 'ACTReasignarTienda',
    label: 'Reasignar Tienda',
    title: <Text fw={700}>Reasignar Tienda</Text>,
    refreshOnClose: true,
    dontRequireSelection: false,
    showActionInViewMode: true,
    views: ['plti_brwGestionTiendasPersonal'],
    onClick: async ({ entity, modal, selectedKeys, element, onClose }) => {

        if (!modal) {
            console.warn('modal context not found');
            return Promise.resolve(false);
        }

        const personaltiendas = entity as PersonalTiendas;
        const personal = new Personal(entity.API.client)

        await modal.open({
            modalProps: {
                title: <Text fw="700">Reasignar tienda</Text>,
                size: 'xl'
            },
            focusOnClosed: element,
            content: <LookupFormAction
                lookupEntity={personal}
                viewName={personal.def.views.perl_brwGestionPersonal.name}
                title="Reasignar tienda a personal seleccionado"
                confirmContent="¿Está seguro de que desea reasignar las tiendas seleccionadas?"
                onActionFinished={async () => { if (onClose) await onClose(); }}
                onOK={
                    async (keys: DataGridSelectionKeys, abortSignal: AbortSignal): Promise<DBStatusResult> => {
                        const abort_controller = new AbortController();

                        if (selectedKeys && selectedKeys.length > 0) {
                            await personaltiendas.API.deleteData(selectedKeys, abort_controller.signal);

                            for (const key of selectedKeys ?? []) {
                                const personaltiendasagregar = new PersonalTiendas(entity.API.client)
                                personaltiendasagregar.def.columns.c_personal_id.value = keys![0].c_personal_id as string;
                                personaltiendasagregar.def.columns.c_tienda_id.value = key.c_tienda_id as string;
                                await personaltiendasagregar.API.addData(abortSignal);
                            }
                        }
                        return { Results: [{ Status: 0, Message: 'OK' }] } as DBStatusResult;
                    }
                }
            />

        });

        return false;
    }
}